export class ConfigurationEvent {

  static ADD_LABEL: string = 'ConfigurationAddLabel';
  static REMOVE_LABEL: string = 'ConfigurationRemoveLabel';
  static MODE_CHANGE: string = 'ConfigurationModeChange'; // EXCEL vs NORMAL
  
  public type: string;
  
  /**
   * Constructor
   */
  constructor(type: string) {
    this.type = type;
  }
}
